<template>
  <v-layout>
    <v-flex 
      xs12 
      sm6 
      offset-sm3>
      <v-card>
        <v-img 
          :src="`static/home-jumbotron.jpg`"
          gradient="to top, rgba(13, 3, 29, .25), rgba(25, 25, 38, .85)"
          aspect-ratio="2.75">
          <v-fade-transition mode="out-in">
            <v-container
              class="white--text"
              fill-height
            >
              <v-layout align-center>
                <v-fade-transition mode="out-in">
                  <v-flex
                    text-xs-center
                  >
                    <h1 
                      class="display-2" 
                      v-text="title" />
                    <div
                      class="subheading"
                      v-text="subtitle"
                      v-if="subtitle"
                    />
                  </v-flex>
                </v-fade-transition>
              </v-layout>
            </v-container>
          </v-fade-transition>
        </v-img>
        <v-card-text>
          <div>
            <h3 class="headline mb-0">Welcome {{ user.displayName }}</h3>
            <div v-html="welcome" />
          </div>
        </v-card-text>
        <v-footer >
          <v-flex
            fill-height
            primary
            lighten-2
            py-2
            text-xs-center
            white--text
            xs12
            v-text="footer"
          />
        </v-footer>
        <v-card-text>
          <v-text-field
            v-model="title"
            label="Title"
          />
          <v-text-field
            v-model="subtitle"
            label="Subtitle"/>
          <label class="v-label theme--light">Welcome message</label>
          <ckeditor 
            :editor="editor" 
            v-model="welcome" 
            :config="editorConfig"/>
          <v-text-field
            v-model="footer"
            label="Footer"/>
          <v-btn 
            large 
            color="primary"
            @click="updateConfig">Update</v-btn>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FirestoreUploadAdapter } from "@/plugins/FirestoreUploadAdapter";

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = loader => {
    // Configure the URL to the upload script in your back-end here!
    // console.log(loader);
    return new FirestoreUploadAdapter(loader);
  };
}

export default {
  data() {
    return {
      breadcrumbs: [
        {
          to: "/",
          text: "NAVIGATION",
          disabled: false,
          exact: false,
          class: "white--text"
        }
      ],
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        mediaEmbed: {
          previewsInData: true
        }
      },
      config: {
        title: "",
        subtitle: "",
        welcome: "",
        footer: ""
      },
      setup: null
    };
  },
  components: {
    ckeditor: CKEditor.component
  },
  firestore() {
    return {
      setup: this.$store.getters.db.doc("setup/config")
    };
  },
  watch: {
    setup: function(val) {
      this.config.title = val.title;
      this.config.subtitle = val.subtitle;
      this.config.welcome = val.welcome;
      this.config.footer = val.footer;
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    title: {
      get: function() {
        return this.config.title;
      },
      set: function(newValue) {
        this.config.title = newValue;
      }
    },
    subtitle: {
      get: function() {
        return this.config.subtitle;
      },
      set: function(newValue) {
        this.config.subtitle = newValue;
      }
    },
    welcome: {
      get: function() {
        return this.config.welcome;
      },
      set: function(newValue) {
        this.config.welcome = newValue;
      }
    },
    footer: {
      get: function() {
        return this.config.footer;
      },
      set: function(newValue) {
        this.config.footer = newValue;
      }
    }
  },
  methods: {
    updateConfig: function() {
      this.$store.dispatch("setLoading", true);
      this.$store.getters.db
        .doc("setup/config")
        .set(this.config)
        .then(() => {
          return this.$store.dispatch("loadConfig");
        })
        .then(() => {
          console.log("Document successfully written!");
          this.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "success",
            timeout: 6000,
            text: "Config saved"
          });
          this.$store.dispatch("setLoading", false);
        })
        .catch(error => {
          console.error("Error writing document: ", error);
          this.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "success",
            timeout: 6000,
            text: "Error saving"
          });
          this.$store.dispatch("setLoading", false);
        });
    }
  }
};
</script>
